import axios from "axios";
import LocalStorageService from "../APIs/token";
import constants from "./constants";

// Axios instance for making API requests
const axiosInstance = axios.create({
  baseURL: constants.BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials: true
});

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = LocalStorageService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor (with refresh token logic as needed)
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = LocalStorageService.getRefreshToken();

      if (refreshToken) {
        try {
          const response = await refreshAxiosInstance.post('/auth/jwt/refresh/', {
            refresh: refreshToken
          });
          const newAccessToken = response.data.access;
          LocalStorageService.setAccessToken(newAccessToken);
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          LocalStorageService.clearToken();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

// Utility function for handling both JSON and multipart-form requests
const apiUtils = {
  getRequest: async (url) => {
    const res = await axiosInstance.get(`${url}`);
    return res;
  },

  // Handle JSON and multipart-form requests
  postRequest: async (url, payload, isMultipart = false) => {
    let res;
    if (isMultipart) {
      console.log("payload", payload);
      // Create a FormData object for multipart/form-data
      // const formData = new FormData();
      // Object.keys(payload).forEach(key => {
      //   formData.append(key, payload[key]);
      // });

      // Perform the request without setting Content-Type (Axios sets it automatically)
      res = await axiosInstance.post(url, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } else {
      // For regular JSON requests
      res = await axiosInstance.post(url, payload);
    }

    return res;
  },

  putRequest: async (url, payload) => {
    const res = await axiosInstance.put(`${url}`, payload);
    return res;
  },

  patchRequest: async (url, payload) => {
    const res = await axiosInstance.patch(`${url}`, payload);
    return res;
  },

  deleteRequest: async (url) => {
    const res = await axiosInstance.delete(`${url}`);
    return res;
  },
};

export default apiUtils;
